import { render, staticRenderFns } from "./WhetherBDOMerchant.vue?vue&type=template&id=55b85c92&scoped=true"
import script from "./WhetherBDOMerchant.vue?vue&type=script&lang=js"
export * from "./WhetherBDOMerchant.vue?vue&type=script&lang=js"
import style0 from "./WhetherBDOMerchant.vue?vue&type=style&index=0&id=55b85c92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b85c92",
  null
  
)

export default component.exports